"use client";

import { useEffect, useState } from "react";

export function PreviewBanner() {
  const [isPreview, setIsPreview] = useState(false);

  useEffect(() => {
    setIsPreview(document.cookie.includes("io.prismic.preview"));
  }, []);

  if (!isPreview) return null;

  function handleExit() {
    fetch("/api/exit-preview").then(() => {
      document.cookie =
        "io.prismic.preview=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      window.location.reload();
    });
  }

  return (
    <div
      className="text-center"
      style={{ color: "white", padding: "3px", backgroundColor: "red" }}
    >
      This is a preview.{" "}
      <button onClick={handleExit} className="underline">
        exit preview mode
      </button>
      .
    </div>
  );
}
